import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import PageContainer from '@/components/PageContainer.vue'
import QuizzHeader from '@/components/Quizz/QuizzHeader.vue'
import TimesUpModal from '@/components/Quizz/TimesUpModal.vue'
import QuitModal from '@/components/QuitModal.vue'
import { quizz } from '@/data/quizz'
import { computed, onMounted, ref } from 'vue'
import MedalProgressBar from '@/components/Quizz/MedalProgressBar.vue'
import { onBeforeRouteLeave, useRouter } from 'vue-router'
import { useStoreQuizz } from '@/stores/quizz'
import { QuizzType } from '@/types/Quizz'
import QuizzIllustration from '@/components/Quizz/QuizzIllustration.vue'
import QuizzQcm from '@/components/Quizz/QuizzQcm.vue'

// Composable

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const quizzStore = useStoreQuizz()
const router = useRouter()

// Refs
const quitModal = ref<InstanceType<typeof QuitModal> | null>(null)
const timesUpModal = ref<InstanceType<typeof TimesUpModal> | null>(null)
const currentQuizz = computed(() => quizz[quizzStore.patternIndex])
const currentQuestionIndex = ref(0)
const selectedAnswersId = ref<number[]>([])
const canQuitModule = ref(false)

// Computed
const currentAnswer = computed(() => {
  return quizzStore.userAnswers.find((answer) => {
    return (
      answer.sentenceId === currentQuizz.value[currentQuestionIndex.value].id
    )
  })
})

const showJustification = computed(() => {
  return currentAnswer.value != null
})

// Methods
onMounted(() => {
  loadStoreAnswer()
})

function loadStoreAnswer() {
  const storeAnswer = currentAnswer.value

  if (storeAnswer) {
    selectedAnswersId.value = storeAnswer.answersId
  } else {
    selectedAnswersId.value = []
  }
}

function onSubmitClick() {
  if (showJustification.value === false) {
    quizzStore.update(
      currentQuizz.value[currentQuestionIndex.value].id,
      selectedAnswersId.value
    )
  } else {
    if (currentQuizz.value.length === currentQuestionIndex.value + 1) {
      canQuitModule.value = true
      router.push('/quizz-awards')
      return
    }

    currentQuestionIndex.value++
    loadStoreAnswer()
  }
}

onBeforeRouteLeave((to, from, next) => {
  if (canQuitModule.value === false) {
    if (!quitModal.value?.isShown) {
      quitModal.value?.show()
    }
    next(false)
  } else {
    next()
  }
})

function onBackHome() {
  canQuitModule.value = true
  router.push('/modules-choice')
}

function showTimesUp() {
  quitModal.value?.hide()
  timesUpModal.value?.show()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(MedalProgressBar, {
      medal: _unref(quizzStore).currentMedal
    }, null, 8, ["medal"]),
    (_unref(currentQuizz))
      ? (_openBlock(), _createBlock(PageContainer, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(QuizzHeader, {
              "quizz-type": _unref(currentQuizz)[currentQuestionIndex.value].type,
              question: _unref(currentQuizz)[currentQuestionIndex.value].question,
              index: currentQuestionIndex.value + 1,
              "questions-length": _unref(currentQuizz).length,
              "show-justification": _unref(showJustification),
              onOnTimerEnd: showTimesUp
            }, null, 8, ["quizz-type", "question", "index", "questions-length", "show-justification"]),
            (_unref(currentQuizz)[currentQuestionIndex.value].type === _unref(QuizzType).QCM)
              ? (_openBlock(), _createBlock(QuizzQcm, {
                  key: 0,
                  currentAnswersId: selectedAnswersId.value,
                  "onUpdate:currentAnswersId": _cache[0] || (_cache[0] = ($event: any) => ((selectedAnswersId).value = $event)),
                  sentence: _unref(currentQuizz)[currentQuestionIndex.value],
                  justification: _unref(currentQuizz)[currentQuestionIndex.value].justification,
                  "disabled-submit-btn": 
        selectedAnswersId.value.length === 0 && !_unref(showJustification)
      ,
                  "show-justification": _unref(showJustification),
                  onOnSubmit: onSubmitClick
                }, null, 8, ["currentAnswersId", "sentence", "justification", "disabled-submit-btn", "show-justification"]))
              : (_openBlock(), _createBlock(QuizzIllustration, {
                  key: 1,
                  currentAnswersId: selectedAnswersId.value,
                  "onUpdate:currentAnswersId": _cache[1] || (_cache[1] = ($event: any) => ((selectedAnswersId).value = $event)),
                  sentence: _unref(currentQuizz)[currentQuestionIndex.value],
                  justification: _unref(currentQuizz)[currentQuestionIndex.value].justification,
                  "disabled-submit-btn": 
        selectedAnswersId.value.length !==
          _unref(currentQuizz)[currentQuestionIndex.value].answers.length &&
        !_unref(showJustification)
      ,
                  "show-justification": _unref(showJustification),
                  onOnSubmit: onSubmitClick
                }, null, 8, ["currentAnswersId", "sentence", "justification", "disabled-submit-btn", "show-justification"])),
            _createVNode(TimesUpModal, {
              ref_key: "timesUpModal",
              ref: timesUpModal,
              onOnShowAnswers: onSubmitClick
            }, null, 512),
            _createVNode(QuitModal, {
              ref_key: "quitModal",
              ref: quitModal,
              onOnBackHome: onBackHome
            }, null, 512)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})